import { APP_INITIALIZER, Provider } from '@angular/core';

import { TranslationScopeLoaderService } from './translation-scope-loader.service';

/**
 * Provide transloco `APP_INITIALIZER`, which will await translations being loaded
 * before proceeding to the application.
 */
export function provideTranslationScopeLoaderInitializer(): Provider {
	return {
		provide: APP_INITIALIZER,
		useFactory: translationScopeLoaderInitializer,
		deps: [TranslationScopeLoaderService],
		multi: true
	};
}

function translationScopeLoaderInitializer(scopeLoader: TranslationScopeLoaderService): () => Promise<void> {
	return () => scopeLoader.start();
}
